import httpResource from "@/components/infrastructures/functions/http/httpResource";

export default class StockService {

    public static async fetchStocks() {
        return (await httpResource.get('/v2/equipment/stock/get')).data;
    }
}